import React from 'react';
import { connect } from 'react-redux';
import ReclamationsTable from './ReclamationsTable';
import withLoader from 'components/Shared/withLoader';
import { updateRechercheCriteres, fetchReclamations, fetchReclamationsIfNeeded } from 'store/reclamation/reclamationsActions';

const ReclamationsTableWithLoader = withLoader(ReclamationsTable);

class ReclamationsTableContainer extends React.Component {

    componentDidMount() {
        window.addEventListener('scroll', this.onScroll, false);
        
        this.props.fetchReclamationsIfNeeded();        
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScroll, false);
    }

    onScroll = () => {
        if (this.props.items.length && (window.innerHeight + window.scrollY) >= (document.body.offsetHeight - 10)) {
            this.handleLoadMoreItems();
        }
    }

    handleLoadMoreItems = () => {
        if (!this.props.isLoading && !this.props.isPaging) {
            let criteres = { ...this.props.criteres, page: this.props.criteres.page + 1 };

            this.props.updateRechercheCriteres(criteres);
            this.props.fetchReclamations();
        }
    }

    render() {
        return <ReclamationsTableWithLoader items={this.props.items} isLoading={this.props.isLoading} isPaging={this.props.isPaging} />;
    }
}

const mapStateToProps = state => ({
    items: Array.from(state.reclamation.reclamations.items),
    isLoading: state.reclamation.reclamations.isLoading,
    isPaging: state.reclamation.reclamations.isPaging,
    criteres: state.reclamation.reclamations.recherche.criteres
});

const mapDispatchToProps = dispatch => ({
    updateRechercheCriteres: criteres => dispatch(updateRechercheCriteres(criteres)),
    fetchReclamations: () => dispatch(fetchReclamations()),
    fetchReclamationsIfNeeded: () => dispatch(fetchReclamationsIfNeeded())
});

export default connect(mapStateToProps, mapDispatchToProps)(ReclamationsTableContainer);
